var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMasterUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.16667H2.5",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6667 5.83333H7.50002C7.04002 5.83333 6.66669 5.46 6.66669 5V3.33333C6.66669 2.87333 7.04002 2.5 7.50002 2.5H16.6667C17.1267 2.5 17.5 2.87333 17.5 3.33333V5C17.5 5.46 17.1267 5.83333 16.6667 5.83333Z",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 9.99999H2.5",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6667 11.6667H7.50002C7.04002 11.6667 6.66669 11.2933 6.66669 10.8333V9.16666C6.66669 8.70666 7.04002 8.33333 7.50002 8.33333H16.6667C17.1267 8.33333 17.5 8.70666 17.5 9.16666V10.8333C17.5 11.2933 17.1267 11.6667 16.6667 11.6667Z",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6667 17.5H7.50002C7.04002 17.5 6.66669 17.1267 6.66669 16.6667V15C6.66669 14.54 7.04002 14.1667 7.50002 14.1667H16.6667C17.1267 14.1667 17.5 14.54 17.5 15V16.6667C17.5 17.1267 17.1267 17.5 16.6667 17.5Z",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 15.8333H3.33333C2.87333 15.8333 2.5 15.46 2.5 15V2.5",
    stroke: "#9AA2B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMasterUnselected);
export default __webpack_public_path__ + "static/media/icon_master_unselected.a8f9494367e88950d5c39091fe430b26.svg";
export { ForwardRef as ReactComponent };